// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3IxtW","footer":"ChangeClinic_footer__jLiQk"};